import Mutations from '../../odata/mutations';

export default { ...new Mutations('productPriceBreak'), ...new Mutations('productPriceBreaks') };
